module Meevo.Plugins.Services {
    "use strict";

    export class ProductUsageSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Resource> {
        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected contextParams: Meevo.IContextParams,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.isInteropContext = true;

        }

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:services', isInterop: true, targetRoute: `services/${this.getParentItemId()}/product-usage/` });
        }

    }
}